import {CardDetails} from "@bounce/shared/enums";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  accountId: string;
};

type Data = CardDetails[];

export const getWalletByAccount = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/payment_methods/account/${variables.accountId}`
  );
  return result.data;
};

export const useGetWalletByAccount = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(["wallet", variables.accountId], getWalletByAccount, variables, options);
};
